import axios from "axios";

export default class UploadApi {

    static async uploadSamContractExport(files){
        let url = '/custom-upload/sam-contract-export';
        let formData = new FormData();
        formData.append('files', files[0]);
        try{
            let response = await axios.post(url, formData);
            return response.data;
        } catch (e) {
            console.log('Could not upload contract export file.', e.message);
            return false;
        }
    }

}